import { IconBarrierBlock } from '@tabler/icons-react'
import { motion } from 'motion/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import FooterLogo from '/footer.svg'
import { AstraCallout } from '~/astra'

/**
 *
 * @returns A page that informs the user that they do not have access to the requested page, and redirects them back after a countdown.
 */
const NoAccess = () => {
    const [countdown, setCountdown] = useState(8)
    const navigate = useNavigate()

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev === 0) {
                    clearInterval(timer)
                    void navigate(-1)
                    return 0
                }
                return prev - 1
            })
        }, 1000)

        return () => {
            clearInterval(timer)
        }
    }, [navigate])

    return (
        <div className="flex h-screen flex-col bg-slate-50">
            <motion.div className="flex h-screen flex-col items-center justify-center gap-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <IconBarrierBlock className="size-36 text-default" />
                <div className="w-80">
                    <AstraCallout size="large" color="info" text={`Du har ikke tilgang til denne siden. Du blir omdirigert om  ${countdown}s...`} />
                </div>
            </motion.div>
            <footer>
                <img className="w-full" src={FooterLogo} alt="Footer" />
            </footer>
        </div>
    )
}

export default NoAccess
